import React, { useCallback } from 'react';
import { TimeType, useTimeView } from '../../../hooks/date';
import { usePrefixCls } from '@byte-design/config';
import { TimeSelect } from './TimeSelect';
export function TimeContent() {
  var timePanel = useTimeView();
  var cls = usePrefixCls('time-content');
  var handleSelect = useCallback(function (type, newValue) {
    timePanel.onSelect(type, +newValue);
  }, []);

  var renderHour = function renderHour() {
    var hourOptions = timePanel.getHourOptions();
    var currentIndex = timePanel.getCurrentIndex(TimeType.HOUR, hourOptions);

    if (hourOptions.length === 0) {
      return null;
    }

    return React.createElement(TimeSelect, {
      type: TimeType.HOUR,
      onSelect: handleSelect,
      timeOptions: hourOptions,
      selectedIndex: currentIndex
    });
  };

  var renderMinute = function renderMinute() {
    var minuteOptions = timePanel.getMinuteOptions();
    var currentIndex = timePanel.getCurrentIndex(TimeType.MINUTE, minuteOptions);

    if (minuteOptions.length === 0) {
      return null;
    }

    return React.createElement(TimeSelect, {
      type: TimeType.MINUTE,
      onSelect: handleSelect,
      timeOptions: minuteOptions,
      selectedIndex: currentIndex
    });
  };

  var renderSecond = function renderSecond() {
    var secondOptions = timePanel.getSecondOptions();
    var currentIndex = timePanel.getCurrentIndex(TimeType.SECOND, secondOptions);

    if (secondOptions.length === 0) {
      return null;
    }

    return React.createElement(TimeSelect, {
      type: TimeType.SECOND,
      onSelect: handleSelect,
      timeOptions: secondOptions,
      selectedIndex: currentIndex
    });
  };

  return React.createElement("div", {
    className: cls
  }, renderHour(), renderMinute(), renderSecond());
}